import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Login, SetPassword } from "../Auth";

function AuthRoute() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/set-new-password" element={<SetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AuthRoute;
